import { getContext, put, select, takeEvery } from 'redux-saga/effects';
import { ADD_PASSENGER, REMOVE_PASSENGER, setPassengers, clearPassengers } from './actions';
import { getPassengersState } from './selectors';
import { PassengerType } from '../../../enums';
import { isResetSelectedOnlyInfants, setPassengerCountLessOrEqualAdt } from './utils';
import { SET_SELECTED_FARE_GROUP } from '../fareGroup/actions';
import { getSelectedFareGroup } from '../fareGroup/selectors';
function* clearConflictedPassengers({ payload: passengerType }) {
    const { SearchForm: { passengersConfig } } = yield getContext('config');
    const state = yield select(getPassengersState);
    const newState = Object.assign({}, state);
    const selectedFareGroup = yield select(getSelectedFareGroup);
    passengersConfig
        .filter(config => config.group === selectedFareGroup || (!config.group && selectedFareGroup === 'Standard'))
        .forEach(config => {
        var _a, _b;
        if (config.code === passengerType.passengerType) {
            (_a = config.noAvailableWith) === null || _a === void 0 ? void 0 : _a.forEach(conflictedCode => {
                newState[conflictedCode] = 0;
            });
        }
        else if ((_b = config.noAvailableWith) === null || _b === void 0 ? void 0 : _b.includes(passengerType.passengerType)) {
            newState[config.code] = 0;
        }
    });
    if (isResetSelectedOnlyInfants(newState, passengersConfig)) {
        Object.keys(newState).forEach(type => {
            newState[type] = 0;
        });
    }
    yield put(setPassengers(newState));
}
function* decrementInfants() {
    const { SearchForm: { passengersConfig } } = yield getContext('config');
    const state = yield select(getPassengersState);
    const selectedFareGroup = yield select(getSelectedFareGroup);
    const adultPassengers = passengersConfig
        .filter(config => config.group === selectedFareGroup || (!config.group && selectedFareGroup === 'Standard'))
        .filter(config => config.code === PassengerType.Adult || config.isAdult);
    const adultCount = adultPassengers.reduce((count, config) => {
        const currentCount = state[config.code];
        return count + currentCount;
    }, 0);
    let newState = Object.assign({}, state);
    newState = setPassengerCountLessOrEqualAdt(newState, adultCount, passengersConfig.filter(config => config.group === selectedFareGroup || (!config.group && selectedFareGroup === 'Standard')), PassengerType.Infant);
    newState = setPassengerCountLessOrEqualAdt(newState, adultCount, passengersConfig.filter(config => config.group === selectedFareGroup || (!config.group && selectedFareGroup === 'Standard')), PassengerType.InfantWithSeat);
    yield put(setPassengers(newState));
}
function* handleFareGroupChanged(action) {
    const { SearchForm: { passengersConfig } } = yield getContext('config');
    yield put(clearPassengers());
    const state = yield select(getPassengersState);
    const newState = Object.assign({}, state);
    passengersConfig
        .filter(passenger => (passenger.group === action.payload && passenger.defaultCount) ||
        (!passenger.group && action.payload === 'Standard' && passenger.defaultCount))
        .forEach(it => {
        newState[it.code] = it.defaultCount;
    });
    yield put(setPassengers(newState));
}
function* handleAddPassenger(action) {
    yield clearConflictedPassengers(action);
    yield decrementInfants();
}
export default function* passengersSaga() {
    yield takeEvery(ADD_PASSENGER, handleAddPassenger);
    yield takeEvery(REMOVE_PASSENGER, decrementInfants);
    yield takeEvery(SET_SELECTED_FARE_GROUP, handleFareGroupChanged);
}
